import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {enableAuthButtonsAccess} from '@Components/login-page/login-page-reducer';
import {useIsRecaptchaLoaded} from '@/hooks/recaptcha/useIsRecaptchaLoaded';

export const useOnRecaptchaRender = (): {
  showGrecaptchaBadge: () => void;
  hideGrecaptchaBadge: () => void;
} => {
  const isRecaptchaLoaded = useIsRecaptchaLoaded();
  const dispatch = useDispatch();

  const showGrecaptchaBadge = (): void => {
    const grecaptchaBadge: HTMLElement | null = document.querySelector('.grecaptcha-badge');
    if (grecaptchaBadge) {
      grecaptchaBadge.style.visibility = 'visible';
      grecaptchaBadge.style.zIndex = '10000';
    }
  };

  const hideGrecaptchaBadge = (): void => {
    const grecaptchaBadge: HTMLElement | null = document.querySelector('.grecaptcha-badge');
    if (grecaptchaBadge) {
      grecaptchaBadge.style.visibility = 'hidden';
    }
  };

  useEffect(() => {
    if (isRecaptchaLoaded) {
      window.PMW.grecaptchaReady = true;
      dispatch(enableAuthButtonsAccess());
      showGrecaptchaBadge();
    }
  }, [isRecaptchaLoaded]);

  return {showGrecaptchaBadge, hideGrecaptchaBadge};
};
